import {
  showDashboard as showDashboardApi
} from './api'

let showDashboard = (params) => dispatch => {
  return showDashboardApi(params)
}

export { showDashboard }
